// const TARGET_PRODUCT_ID = 9814653960504;

// console.log('🛒 Cart drawer trigger script initialized');

// // Step 1: Listen for the product being added to the cart
// document.addEventListener('theme:product:add', function(event) {
//   console.log('✅ Product added:', event.detail);

//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       console.log('📦 Current cart:', cart);

//       const found = cart.items.some(item => item.product_id === TARGET_PRODUCT_ID);
//       console.log('🔍 Target product found?', found);

//       if (found) {
//         sessionStorage.setItem('openCartDrawerOnLoad', '1');
//         console.log('💾 Flag set. Reloading...');
//         setTimeout(() => window.location.reload(), 0);
//       }
//     });
// });

// // Step 2: On page load, simulate cart drawer toggle if flag is set
// window.addEventListener('load', function() {
//   console.log('📄 Page fully loaded');

//   if (sessionStorage.getItem('openCartDrawerOnLoad') === '1') {
//     sessionStorage.removeItem('openCartDrawerOnLoad');
//     console.log('🚪 Ready to open cart drawer...');

//     const waitForCartToggleButton = () => {
//       const toggleBtn = document.querySelector('[data-cart-toggle]');
//       console.log('🔍 Looking for cart toggle button...', toggleBtn);

//       if (toggleBtn) {
//         console.log('🖱 Clicking cart toggle button...');
//         toggleBtn.click();
//       } else {
//         console.log('❌ Toggle button not found, retrying...');
//         setTimeout(waitForCartToggleButton, 100);
//       }
//     };

//     waitForCartToggleButton();
//   } else {
//     console.log('ℹ️ No cart drawer flag found — not opening cart drawer.');
//   }
// });
document.addEventListener('theme:product:added', function() {
  // Evey attendee info refresh trigger
  var input = document.createElement('input');
  input.type = 'hidden';
  input.setAttribute('data-trigger-evey-refresh-cart', 'true');
  document.body.appendChild(input);
  input.dispatchEvent(new Event('change', { bubbles: true }));
  setTimeout(function() { input.remove(); }, 100);
});
